import {CLERK_PRICELIST, COMPANY_PRICELIST, COMPANY_PRICELIST_UPDATE,CLERK_PRICELIST_UPDATE,CLEAR_DATA} from '../actions/price_list_action';
import {CreateReducer} from '../utils/create_reducer';

const initState = {
    priceData: {},
    isPriceFetching: true,
    errorMessage: undefined,
    clerkPriceData:{}
};

const priceListReducer = CreateReducer(initState, {
    [CLERK_PRICELIST](state, action) {
        return {...state, clerkPriceData: action.payload.priceData, isPriceFetching: false};
    },
    [COMPANY_PRICELIST](state, action) {
        return {...state, priceData: action.payload.priceData, isPriceFetching: false};
    },
    [COMPANY_PRICELIST_UPDATE](state, action) {
        return {...state, responseMessage: action.payload, isPriceFetching: false};
    },
    [CLERK_PRICELIST_UPDATE](state, action) {
        return {...state, responseMessage: action.payload, isPriceFetching: false};
    },
    [CLEAR_DATA](state,action){
        return {...initState}
    }
});

export default priceListReducer;


// WEBPACK FOOTER //
// ./src/reducers/pricelist_reducer.js